import { useCallback, useEffect, useReducer } from 'react'

interface UseCompensationsRefreshOptions {
  refreshFnRef?: React.MutableRefObject<(() => void) | null>
}

export function useCompensationsRefresh(options: UseCompensationsRefreshOptions = {}) {
  const { refreshFnRef } = options

  const [refreshKey, forceRefresh] = useReducer((x: number) => x + 1, 0)

  const refreshCompensations = useCallback(() => {
    forceRefresh()
  }, [])

  useEffect(() => {
    if (refreshFnRef) {
      refreshFnRef.current = refreshCompensations
    }
  }, [refreshCompensations, refreshFnRef])

  return {
    refreshKey,
    refreshCompensations,
  }
}
